import { render, staticRenderFns } from "./SizeAdd.vue?vue&type=template&id=1ec3433b&scoped=true&"
import script from "./SizeAdd.vue?vue&type=script&lang=js&"
export * from "./SizeAdd.vue?vue&type=script&lang=js&"
import style0 from "./SizeAdd.vue?vue&type=style&index=0&id=1ec3433b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec3433b",
  null
  
)

export default component.exports